import { render, staticRenderFns } from "./CalculateAverageAtomicMassIsotopic.vue?vue&type=template&id=098e816c&scoped=true&"
import script from "./CalculateAverageAtomicMassIsotopic.vue?vue&type=script&lang=js&"
export * from "./CalculateAverageAtomicMassIsotopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e816c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
